import { StyleSheet } from 'react-native';

export const styles = StyleSheet.create({
  // Button base styles
  button: {},
  buttonSmall: {
    borderRadius: 999,
    paddingVertical: 8,
    paddingHorizontal: 24,
    alignItems: 'center',
    justifyContent: 'center',
  },
  buttonDefault: {
    borderRadius: 999,
    paddingVertical: 12,
    paddingHorizontal: 24,
    alignItems: 'center',
    justifyContent: 'center',
  },
  buttonFill: { width: '100%' },
  buttonHug: { alignSelf: 'flex-start' },
  buttonCenter: { alignSelf: 'center' },
  buttonAbsolute: {
    position: 'absolute',
    width: '100%',
  },

  // Button inner styles
  buttonInnerSmall: {},
  buttonInnerDefault: {},

  // Text styles
  text: {},
  textSmall: {
    fontSize: 14,
    fontWeight: '700',
    lineHeight: 18,
  },
  textDefault: {
    fontSize: 16,
    fontWeight: '700',
    lineHeight: 20,
  },
  textHover: {},
  textDisabled: {},
  textFocus: {},
  textPressed: {},

  // Icon styles
  icon: {},
  iconSmall: {
    width: 16,
    height: 16,
  },
  iconDefault: {
    width: 16,
    height: 16,
  },
  iconHover: {},
  iconDisabled: {},
  iconPressed: {},

  wrapper: { flex: 1, flexDirection: 'row', alignItems: 'center', gap: 8 },
});
